"use client";

import classNames from "classnames";
import type { StaticImageData } from "next/image";
import Image from "next/image";
import { useState } from "react";
import styles from "./ProjectImage.module.css";

type Props = {
  src: StaticImageData | string;
  alt: string;
  width: number;
  height: number;
  className?: string;
};

export const ProjectImage = ({ src, alt, width, height, className }: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={styles.imageContainer}>
      {!isLoaded && <div className={styles.placeholder} />}
      <Image
        className={classNames(styles.image, className)}
        width={width}
        height={height}
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)}
        style={{ opacity: isLoaded ? 1 : 0 }}
        priority={true}
      />
    </div>
  );
};
